/**
 *
 * @returns {any}
 * @param typeId
 * @param orderId
 */
export function showOrder(orderId, typeId = 0) {
  return axios({
    url: `/api/orders/${orderId}/${typeId}`,
    method: 'get',
  });
}

/**
 *
 * @param orderId
 * @returns {*}
 */
export function replicateMiniKaskoOrder(orderId) {
  return axios({
    url: `/api/insurance/mini-kasko/orders/${orderId}/replicate`,
    method: 'post',
  });
}

/**
 *
 * @param data
 * @returns {*}
 */
export function saveOrder(data) {
  return axios({
    url: `/api/${process.env.VUE_APP_SERVER_MODE}/insurance/order/osago`,
    method: 'post',
    data: data,
  });
}

/**
 *
 * @param orderId
 * @returns {*}
 */
export function concludeOrder(orderId) {
  return axios({
    url: `/api/${process.env.VUE_APP_SERVER_MODE}/insurance/contract/confirm`,
    method: 'post',
    data: {
      orderId: orderId
    },
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
export function list(params) {
  return axios({
    url: '/api/orders/list',
    method: 'post',
    data: params
  });
}

/**
 *
 * @param params
 * @returns {*}
 */
export function whollyList(params) {
  return axios({
    url: '/api/orders/wholly-list',
    method: 'post',
    data: params
  });
}

/**
 *
 * @param contractId
 * @param typeId
 * @returns {*}
 */
export function downloadContract(contractId, typeId) {

  return axios({
    url: '/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/contract/take',
    method: 'post',
    data: {
      contractId: contractId,
      orderType: typeId,
    },
  });
}

/**
 * @param userId
 * @param orderId
 * @param type
 * @returns {*}
 */
export function showContractFile(userId, orderId, type = 'osago') {
  return window.open(`/api/orders/show-contract/${userId}/${orderId}?type=${type}`);
}

/**
 *
 * @param userId
 * @param orderId
 * @returns {Window}
 */
export function downloadOrder(userId, orderId) {
  return window.open(`/api/orders/draft/${userId}/${orderId}`);
}

/**
 *
 * @param query
 * @returns {Promise<any>}
 */
export function downloadExcel(query) {
  return axios.post('/api/orders/excel', query, {
    responseType: 'blob'
  });
}

/**
 *
 * @param userId
 * @param orderId
 * @returns {Window}
 */
export function downloadActOfCompletedWork(userId, orderId) {
  return window.open(`/api/orders/act-completed-work/${userId}/${orderId}`);
}

/**
 *
 * @param params
 * @returns {*}
 */
export function prolongation(params) {
  return axios({
    url: '/api/orders/prolongation',
    method: 'post',
    data: params
  });
}

/**
 *
 * @param data
 * @returns {*}
 */
export function changeProlongStatus(data) {
  return axios({
    url: '/api/orders/prolongation/status',
    method: 'post',
    data: data,
  });
}

/**
 *
 * @returns {*}
 */
export function countNeedProlongation() {
  return axios({
    url: '/api/orders/prolongation-count',
    method: 'get'
  });
}

/**
 *
 * @param link
 * @returns {Promise<any>}
 */
export function downloadPdf(link) {
  return fetch(link)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.blob();
    })
    .then(blob => {
      return { data: blob };
    });
}

/**
 *
 * @param orderId
 * @param amount
 * @param invoiceType
 * @param payParts
 * @param usageMonths
 * @param provider
 * @param paidBy
 * @returns {*}
 */
export function getPaymentInvoice(
  orderId,
  amount = null,
  invoiceType = null,
  payParts = 2,
  usageMonths = null,
  provider = null,
  paidBy = null,
  installmentTerm = null,
) {
  return axios({
    url: '/api/orders/get-invoice',
    method: 'post',
    data: {
      provider: provider,
      paidBy: paidBy,
      orderId: orderId,
      amount: amount,
      type: invoiceType,
      payParts: payParts,
      usageMonths: usageMonths,
      installmentTerm: installmentTerm
    }
  });
}

/**
 *
 * @param invoiceId
 * @returns {*}
 */
export function monoPayPartsStatus(invoiceId) {
  return axios({
    url: '/api/payments/mono-pay-parts-status',
    method: 'post',
    data: { invoiceId: invoiceId }
  });
}

/**
 *
 * @param userId
 * @param orderId
 * @param params
 * @returns {Window}
 */
export function downloadInvoiceLegal(userId, orderId, params) {
  return window.open(`/api/orders/show-invoice-legal/${userId}/${orderId}?${params}`, '_blank');
}

/**
 *
 * @param orderId
 * @param type
 * @param commissionPaidBy
 */
export function sendOtp(orderId, type, commissionPaidBy = null) {
  return axios({
    url: `/api/orders/send-otp/${orderId}`,
    method: 'post',
    data: { type: type, commissionPaidBy: commissionPaidBy }
  });
}
/**
 *
 * @param orderId
 * @param otp
 * @param additionalOtps
 */
export function checkOtp(orderId, otp, additionalOtps = {}) {
  return axios({
    url: `/api/orders/check-otp/${orderId}`,
    method: 'post',
    data: {
      otp: otp,
      additional_otps: additionalOtps
    }
  });
}


/**
 *
 * @param orderId
 */
export function checkOtpSubmitted(orderId) {
  return axios({
    url: `/api/orders/${orderId}/check-otp-submitted`,
    method: 'get',
  });
}


/**
 *
 * @param params
 */
export function listActs(params = null) {
  return axios({
    url: '/api/orders/list-acts',
    method: 'get',
    params: params,
  });
}
